import {Component, inject, OnInit} from '@angular/core';
import {LocaleService} from "../../../../locale/locale.service";
import {ClaimsService} from "../../../../services/claims.service";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {InvolvedVehicleType} from "../../../../enums/involved-vehicle-type";
import {FooterComponent} from "../../../common/footer/footer.component";
import {HeaderComponent} from "../../../common/header/header.component";
import {VehicleIncidentStatusType} from "../../../../enums/vehicle-incident-status-type";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';

@Component({
  selector: 'app-vehicle-accident-status',
  imports: [
    FooterComponent,
    HeaderComponent,
    ReactiveFormsModule
  ],
  templateUrl: './vehicle-accident-status.component.html',
  styleUrl: './vehicle-accident-status.component.css'
})
export class VehicleAccidentStatusComponent implements OnInit {
  locale = inject(LocaleService);
  private formNavigationService = inject(FormNavigationService);
  private claimService = inject(ClaimsService);

  showError: boolean = false;
  options: { headline: string, caption: string, value: string }[] = [];
  radioControl = new FormControl();
  isDriver = false;

  ngOnInit(): void {
    this.claimService.getData().subscribe(() => {
      this.isDriver = this.claimService.isDriver();
      this.options = [
        {
          headline: this.isDriver ? this.locale.currentTranslation.vehicleAccidentStatusOptionHeadline1 : this.locale.currentTranslation.thirdPartyVehicleAccidentStatusOptionHeadline1,
          caption: this.isDriver ? this.locale.currentTranslation.vehicleAccidentStatusOptionCaption1 : this.locale.currentTranslation.thirdPartyVehicleAccidentStatusOptionCaption1,
          value: VehicleIncidentStatusType.InMotion
        },
        {
          headline: this.isDriver ? this.locale.currentTranslation.vehicleAccidentStatusOptionHeadline2 : this.locale.currentTranslation.thirdPartyVehicleAccidentStatusOptionHeadline2,
          caption: this.isDriver ? this.locale.currentTranslation.vehicleAccidentStatusOptionCaption2 : this.locale.currentTranslation.thirdPartyVehicleAccidentStatusOptionCaption2,
          value: VehicleIncidentStatusType.Parked
        },
      ]
      this.radioControl = new FormControl(this.claimService.claimReport().vehicleIncidentStatusType);
    })
  }

  nextClicked() {
    this.evaluateShowError()
    const rawValue = this.radioControl.getRawValue();
    if (!this.showError) {
      this.claimService.updateClaimReport({vehicleIncidentStatusType: rawValue});
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['vehicle-accident-status']);
      });
    }
  }

  private evaluateShowError() {
    let rawValue = this.radioControl.getRawValue();
    this.showError = rawValue == null;
  }

  setOption(value: string) {
    this.radioControl.patchValue(value);
    this.showError = false
  }
}
